export const TEXT_EDITOR_PAGE_ORIENTATION = {
  PORTRAIT: 'portrait',
  LANDSCAPE: 'landscape',
};

export const TEXT_EDITOR_DEFAULT_PAGE_ORIENTATION = TEXT_EDITOR_PAGE_ORIENTATION.PORTRAIT;

/** ISO A4 (210 × 297 mm), converted for CSS px and export. */
const A4_WIDTH_MM = 210;
const A4_HEIGHT_MM = 297;
const MM_PER_IN = 25.4;
const CSS_PX_PER_IN = 96;

const A4_WIDTH_IN = A4_WIDTH_MM / MM_PER_IN;
const A4_HEIGHT_IN = A4_HEIGHT_MM / MM_PER_IN;

export const TEXT_EDITOR_A4_WIDTH_PX = Math.round(A4_WIDTH_IN * CSS_PX_PER_IN);
export const TEXT_EDITOR_A4_HEIGHT_PX = Math.round(A4_HEIGHT_IN * CSS_PX_PER_IN);

export function normalizeTextEditorPageOrientation(value) {
  return value === TEXT_EDITOR_PAGE_ORIENTATION.LANDSCAPE
    ? TEXT_EDITOR_PAGE_ORIENTATION.LANDSCAPE
    : TEXT_EDITOR_PAGE_ORIENTATION.PORTRAIT;
}

export function getTextEditorPageLayoutMetrics(orientation) {
  const resolved = normalizeTextEditorPageOrientation(orientation);
  const landscape = resolved === TEXT_EDITOR_PAGE_ORIENTATION.LANDSCAPE;
  const widthIn = landscape ? A4_HEIGHT_IN : A4_WIDTH_IN;
  const heightIn = landscape ? A4_WIDTH_IN : A4_HEIGHT_IN;
  return {
    orientation: resolved,
    widthIn,
    heightIn,
    widthPx: Math.round(widthIn * CSS_PX_PER_IN),
    heightPx: Math.round(heightIn * CSS_PX_PER_IN),
    pdfJsOrientation: landscape ? 'l' : 'p',
    wordPageSizeCss: landscape ? 'A4 landscape' : 'A4 portrait',
  };
}
